import React from "react"
import { Dropdown, Image } from "react-bootstrap"
import {
  arrowDownIcon,
  editIcon,
  logoutIcon,
  settingIcon,
} from "../../constants/icons"
import { useNavigate } from "react-router-dom"
import { FaRegUser } from "react-icons/fa"
import {
  setToastBoxDescription,
  setToastBoxStatus,
} from "../../redux/ToastBoxSlice"
import { useDispatch } from "react-redux"

function UserDropdown({ user, handleLogout }) {
  const dispatch = useDispatch()
  if (!user || !user.name || !user.avatar) return null

  return (
    <Dropdown className='common-dropdown user-dropdown'>
      <Dropdown.Toggle id='dropdown-user'>
        {/* <Image
                    src={user.avatar}
                    roundedCircle
                    width={40}
                    height={40}
                    className="me-1"
                /> */}
        <FaRegUser />

        <span className='user-name'>{user.name}</span>
        {/* <span className='user-arrow'>{arrowDownIcon}</span> */}
      </Dropdown.Toggle>

      <Dropdown.Menu align='end'>
        {/* <Dropdown.Item href='#edit-profile'>
          {editIcon} <span title='Edit profile'>Edit profile</span>
        </Dropdown.Item> */}
        {/* <Dropdown.Item href='#settings'>
          {settingIcon} <span title='Settings'>Settings</span>
        </Dropdown.Item> */}
        {/* <Dropdown.Item onClick={handleLogout}>
          {logoutIcon} <span title='Logout'>Logout</span>
        </Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default UserDropdown
